import { useSession } from 'components/auth/useSession'
import { useFlags } from 'config/useFlagsContext'
import Permissions from 'types/Permissions'

export function useSaudeIndigenaAuthorization() {
  const { hasAuthorization } = useSession()
  const { SAUDE_INDIGENA_ENABLED } = useFlags()

  const hasCadastrarEditarAldeadoPermission =
    SAUDE_INDIGENA_ENABLED &&
    hasAuthorization(
      Permissions.gestaoDeCadastros.visualizarCadastroIndividual.cadastrarEEditar.cadastrarEEditarCidadaoAldeado
    )

  const hasTerritorioIndigenaPermission =
    SAUDE_INDIGENA_ENABLED &&
    hasAuthorization(Permissions.gestaoDeCadastros.acompanhamentoTerritorio.territorioIndigena)

  return {
    hasCadastrarEditarAldeadoPermission,
    hasTerritorioIndigenaPermission,
  }
}
